<div class="container-fluid">
  <div class="row">
    <div class="col-md-7">
      <div class="row g-3">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header justify-content-between align-items-center d-flex">
              <h3 class="card-title">{{ requestId ? 'Update Request' : ' Create Request' }} </h3>

              <div class="ms-auto ">
                <a class="btn btn-success me-2" routerLink="/app/clients/create">
                  New Customer
                </a>
                <button type="button" class="btn btn-success" (click)="gotoViewRequest()"
                  [disabled]="!requestId">
                  View Request
                </button>
              </div>
            </div>
            <div class="card-body">
              <requests-form [request]="request" [requestId]="requestId" [isEditPage]="true"
                (onSavedData)="onRequestFormSavedData($event)" />
            </div>
          </div>
        </div>
        <div class="col-12">
          <requests-details [request]="request" (onSavedData)="onRequestFormSavedData($event)" />
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <requests-date [request]="request" [requestCategory]="category" (onSavedData)="onRequestFormSavedData($event)" />
    </div>
  </div>
  <div class="row">
    <div class="col-6 mx-auto">
      <div class="text-center mt-4">
        <button type="button" class="btn btn-success px-4 py-2" (click)="submitAllForms()">
          Save
        </button>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <notes-customers-form [readonlyCustomerNotes]="false" [customer]="requestNotes"
        [noteServiceMethod]="requestsService" [addNoteMethod]="'createNotes'" [deleteNoteMethod]="'deleteNotes'"
        [sectionAttribute]="'requestId'" />
    </div>
  </div>

</div>